module.exports = {"content":[{"id":0,"quote":"I got to watch a Pilot on my favorite network before it was released - It was crazy to watch the same pilot on TV and see how they tweaked the show based on my feedback.","image":"default","name":"sdouglass1983"},{"id":1,"quote":"As an avid movie goer, I'm always looking for new things to watch. Now, I can watch exclusive content before it's released and earn rewards for my opinions.","image":"default","name":"KatNapKing"}]}


//////////////////
// WEBPACK FOOTER
// ./src/content/viewer-content.json
// module id = 696
// module chunks = 0